export { useTrackErrorPageView } from './use-track-error-page-view.js';
//# sourceMappingURL=hooks.js.map
